module.exports = __webpack_public_path__ + "static/media/lift.d4a81c93.png";